<script lang="ts">
    import ZentitySelect from '../../_common/z/zentity-select.svelte'
    import { onMount } from 'svelte'
    import DateSelect from '../../_common/date-select.svelte'
    import { GridButton, GridClass, GridCol, GridColTypeEnum, GridLine } from '../../_common/z/zgrid'
    import Grid from '../../_common/z/zgrid.svelte'
    import type { Invoice } from '../../../modules/posApi/invoices/invoice'
    import LoadSpinner from '../../_common/load-spinner.svelte'
    import type { User } from '../../../modules/usersApi/users/user'
    import type { Person } from '../../../modules/eventsApi/persons/person'
    import Zflow from '../../_common/z/zflow.svelte'
    import type { Service } from '../../../modules/posApi/services/service'
    import type { PaymentMethod } from '../../../modules/posApi/payment-methods/payment-methods'
    import Zbutton from '../../_common/z/zbutton.svelte'
    import { faUser, faPrint } from '@fortawesome/free-solid-svg-icons'

    let dateSelect: { from: Date; to: Date } = window.api.utils.dates.today()

    onMount(async () => {
        await loadInvoices(dateSelect.from, dateSelect.to)
        await generateData()
    })

    let show = false
    let user: User = null

    interface dataInterface {
        name: string
        paymentMethodId: string
        invoices: {
            date: Date
            sellers: string[]
            sellersId: string[]
            person: Person
            invoice: Invoice
            services: string[]
            installments: number
            total: number
        }[]
    }
    let data: dataInterface[] = []

    let invoices: Invoice[] = []
    async function loadInvoices(from: Date, to: Date) {
        if (show) return
        invoices = []
        show = true
        //let paymentMethods: PaymentMethod[] = await window.api.pos.paymentMethods.getAll()
        let users: User[] = await window.api.users.companies.getCompanyUsers(600)
        let services: Service[] = await window.api.pos.services.getAll({ type: 'all' }, 600)
        invoices = await window.api.pos.invoices.getAll({ from, to, service: true })
        invoices = await window.api.utils.utils.assignPersonsFromObject(invoices)
        for (const invoice of invoices) {
            invoice.services = invoice.services.map((el) => {
                el.user = users.find((u) => u.userId === el.userId)
                el.service = services.find((s) => s.serviceId === el.serviceId)
                return el
            })
        }
        // for (const invoice of invoices) {
        //     for (const payment of invoice.payments) {
        //         payment.paymentMethod = paymentMethods.find((el) => el.paymentMethodId === payment.paymentMethodId)
        //     }
        // }
        console.log('relat.invoices', invoices)
        show = false
    }

    function generateData() {
        data = []

        for (const invoice of invoices) {
            for (const payment of invoice.payments) {
                let item: dataInterface = data.find((el) => el.paymentMethodId === payment.paymentMethodId)
                if (!item) {
                    item = { name: payment.paymentMethod?.label, paymentMethodId: payment.paymentMethodId, invoices: [] }
                    data.push(item)
                }
                item.invoices.push({
                    date: invoice.createdAt,
                    person: invoice.person,
                    invoice: invoice,
                    sellers: [...new Set(invoice.services.map((el) => el.user?.userName))],
                    sellersId: [...new Set(invoice.services.map((el) => el.userId))],
                    services: invoice.services.map((el) => el.service?.name).filter((el) => !!el),
                    installments: payment.installments,
                    total: payment.value,
                })
            }
        }
        loadGrid()
    }

    let manySellers = false
    let grids: GridClass[] = []
    function loadGrid() {
        grids = []
        manySellers = false
        for (const pm of data) {
            const grid = new GridClass()
            grid.title = pm.name
            grid.showActs = false
            //grid.subtitle = 'Período de ' + dayjs(from).format('DD/MM/YYYY') + ' até ' + dayjs(to).format('DD/MM/YYYY')
            grid.cols.push(new GridCol({ content: 'Data', type: GridColTypeEnum.date }))
            grid.cols.push(new GridCol({ content: 'Cliente' }))
            grid.cols.push(new GridCol({ content: 'Vendedores' }))
            grid.cols.push(new GridCol({ content: 'Serviços' }))
            grid.cols.push(new GridCol({ content: 'Parcelas', size: 1, type: GridColTypeEnum.int }))
            grid.cols.push(new GridCol({ content: 'Total', showTotal: true, size: 1, type: GridColTypeEnum.float_2 }))
            grid.cols.push(new GridCol({ type: GridColTypeEnum.button }))
            for (const invoice of pm.invoices) {
                if (user?.userId && !invoice.sellersId.includes(user.userId)) continue

                let line: GridLine = new GridLine()
                line.slots.push({ content: invoice.date })
                line.slots.push({ content: invoice.person?.name })
                line.slots.push({ content: invoice.sellers.join(', ') })
                line.slots.push({ content: invoice.services.join(', ') })
                line.slots.push({ content: invoice.installments })
                line.slots.push({ content: invoice.total })
                line.slots.push({ content: [new GridButton({ callback: () => window.person('show', invoice.invoice.personId), icon: faUser })] })
                grid.lines.push(line)
                if (invoice.sellers.length > 1) manySellers = true
            }
            if (grid.lines.length > 0) grids.push(grid)
        }
        grids = grids
        console.log('relat.grids', grids)
    }

    async function dateOnChange(event) {
        dateSelect = event.detail
        await loadInvoices(dateSelect.from, dateSelect.to)
        await generateData()
    }

    async function userOnChange() {
        await generateData()
    }
</script>

<div class="relat-body">
    <div class="acts h-print d-flex">
        <div class="date me-2">
            <DateSelect on:change={dateOnChange} />
        </div>
        <ZentitySelect fonte="usuario" label="Vendedor" opcaoVazia="Todos" class="me-2" bind:value={user} on:change={userOnChange}></ZentitySelect>
        <Zbutton icon={faPrint} on:click={() => window.print()}></Zbutton>
    </div>
    <Zflow class="mt-2">
        {#each grids as grid}
            <Grid {grid} />
        {/each}
    </Zflow>
    <!-- <div class="alert alert-warning mt-2 text-center">
        Atenção: este relatório está em fase experimental (beta).<br />
        Em caso de dúvidas ou divergências entre em contato com o suporte para mais orientações.
    </div> -->

    {#if manySellers}
        <div class="alert alert-danger mt-2 text-center">
            Atenção: há vendas onde mais de um vendedor participou da transação.<br />
            Caso pretenda utilizar este relatório para realizar pagamentos, faça o rateio dos valores entre cada vendedor.<br />
        </div>
    {/if}
</div>
<LoadSpinner {show}></LoadSpinner>
